<template>
  <div class="miya-resetPassword">
    <div class="card">
      <slot name="title"></slot>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <p class="inputName">{{$t('login.email')}}</p>
        <el-form-item label="" prop="email" label-width="0">
          <el-input size="medium" v-model="ruleForm.email" :placeholder="$t('login.placeholder1')">
            <!-- <template slot="append">
              <el-select class="selectMail" filterable clearable v-model="suffix">
                <el-option v-for="(item, idx) in list" :key="'email'+idx" :label="item" :value="item"></el-option>
              </el-select>
            </template> -->
          </el-input>
        </el-form-item> 
        <p class="inputName">{{$t('login.emailCode')}}</p>
        <el-form-item label="" prop="emailCode" label-width="0">
          <div class="emailCode">
            <el-input size="medium" v-model="ruleForm.emailCode" :placeholder="$t('login.placeholder2')"></el-input>
            <el-button type="info" class="sendBtn" size="medium" :disabled="disabledSendBtn" :class="{isDisabled: disabledSendBtn}" @click.stop="clickSendCode()">{{intervalIdx==0?$t('login.sendCode'):intervalIdx+' s'}}</el-button>
          </div>            
        </el-form-item>
        <p class="tipString">{{$t('login.codeTip')}}</p>
        <div class="password-box">
          <div class="item">              
            <p class="inputName">{{$t('login.password')}}</p>
            <el-form-item label="" prop="password" label-width="0">
              <el-input show-password size="medium" v-model="ruleForm.password" :placeholder="$t('login.placeholder3')"></el-input>
            </el-form-item>
          </div>
          <div class="item">              
            <p class="inputName">{{$t('login.repeatPassword')}}</p>
            <el-form-item label="" prop="repeatPassword" label-width="0">
              <el-input show-password size="medium" v-model="ruleForm.repeatPassword" :placeholder="$t('login.placeholder3')"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <!-- <div class="checkbox"></div> -->
      <miya-btn ref="miyaBtn" @click="clickOK()" :title="$t('login.btnOK')" class="loginBtn"></miya-btn>
      <slot name="btnCancel"></slot>
    </div>
  </div>
</template>
<script>
import miyaBtn from '@components/miyaBtn.vue'
export default {
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('login.errorPassword')))
      } else {
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('login.errorPassword')))
      } else if (value !== this.ruleForm.password) {
        callback(new Error(this.$t('login.repeatPassword1')))
      } else {
        callback()
      }
    }
    var validateMail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('login.errorEmail')))
      } else if (!this.suffix) {
        var regex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
        if (!regex.test(value)) {
          callback(new Error(this.$t('login.errorEmail')))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      suffix: '',
      list: ['@qq.com', '@163.com', '@gmail.com', '@126.com', '@msn.cn', '@live.com', '@lcx.cc', '@vip.qq.com', '@vip.163.com', '@aliyun.com', '@sina.cn', '@sina.com', '@sohu.com', '@21cn.com', '@189.cn', '.edu.cn', '@yeah.net', '@foxmail.com', '@icloud.com', '@bayblue.hk', '@proton.me', '@protonmail.com', '@pm.me'],
      intervalIdx: 0,
      ruleForm: {
        email: '',
        password: '',
        emailCode: '',
        repeatPassword: '',
      },
      rules: {
        email: [
          {validator: validateMail, trigger: 'blur'}
        ],
        password: [
          {validator: validatePass, trigger: 'blur'}
        ],
        repeatPassword: [
          {validator: validatePass2, trigger: 'blur'}
        ],
      },
      isValidate: false,
    }
  },
  computed: {
    disabledSendBtn () {
      if (this.ruleForm.email.trim().length > 0 && this.intervalIdx == 0) {
        return false
      } else {
        return true
      }
    },
  },
  mounted () {  
  },
  methods: {
    getData () {
      this.rules.email[0].message = this.$t('login.errorEmail')
      if (this.isValidate) {
        this.$refs.ruleForm.validate(v => {})
      }      
    },
    clickSendCode () {
      if (!this.disabledSendBtn) {
        this.intervalIdx = 50
        this.countdown()
        this.$get(`/Check/SendSms?phone=${!this.suffix ? this.ruleForm.email : this.ruleForm.email + this.suffix}`).then(res => {
          if (res.cod === 500) {
            this.$message.error(res.message)
          }
        })
      }
    },
    countdown () {
      if (this.intervalIdx !== 0) {
        this.intervalIdx--
        setTimeout(() => {
          this.countdown()
        }, 1000)
      }      
    },
    clickOK () {
      this.$refs.ruleForm.validate(v => {
        this.isValidate = true
        if (v) {
          this.$refs.miyaBtn.disabledBtn()
          let account = !this.suffix ? this.ruleForm.email : this.ruleForm.email + this.suffix
          this.$post(`/Check/ResetPwByMail?mailCode=${this.ruleForm.emailCode}`, {
            account: account,
            password: this.ruleForm.password,
            phoneNum: account,
          }).then(res => {
            this.$refs.miyaBtn.enabledBtn()
            if (res.code === 500) {
              this.$message.error(res.message)
            } else if (res.code === 200) {
              this.$emit('success')
            }
          })
        }
      })
    },
  },
  beforeDestroy () {
  },
  watch: {
    language () {
      this.getData()
    },
  },
  components: {miyaBtn}
}
</script>
<style scoped lang="stylus">
.miya-resetPassword
  display flex
  .card
    width 40%
    min-width 450px
    margin 30px auto 0 auto
    color $c1
  .title1
    font-size 40px
    text-align center
    margin-bottom 56px
  .inputName
    font-size $f16
    margin 36px 0 12px 0
    fontWeight()
  .emailCode
    display flex
    .sendBtn
      margin-left 10px
      width 180px
      height 36px
      position relative
      top 2px
      border-radius 0
    .isDisabled
      border 1px solid #D0CFCE
      background-color #D0CFCE
      &:hover
        box-shadow none
        background-color #D0CFCE
  .tipString
    font-size $f14
    color $c2
    margin-top -16px
    margin-bottom 12px
  .password-box
    display flex
    .item
      flex 1
      &:last-child
        margin-left 24px
  .checkbox
    margin-top 32px
    display flex
  .checkText
    font-size 16px
    color $c1
    line-height 20px
    margin-left 8px
    .click
      color $c8
      cursor pointer
  .loginBtn
    line-height 54px
    text-align center
    letter-spacing 1px
    color $c7
    border-radius 2px
    font-size $f20
    margin 16px 0
    width 100%
    border none
    background: linear-gradient(88deg, #FF8F10 0%, #FF6F00 100%);
    &:hover                
      box-shadow: 0px 8px 15px 1px rgba(255,201,159,0.6);
  .account
    display flex
    justify-content space-between
    color $c2
    margin-left 0
    .forgetPassword
      color $c1
      cursor pointer
      
</style>
<style lang="stylus">
.miya-resetPassword
  .el-input__inner
    border 1px solid #f5f5f5
  .el-input__inner:focus
    border 1px solid $c8
  .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus
    background rgba(255,57,35,0.06)
  .el-form-item.is-error .selectMail .el-input__inner, .el-form-item.is-error .selectMail .el-input__inner:focus, .el-form-item.is-error .selectMail .el-textarea__inner, .el-form-item.is-error .selectMail .el-textarea__inner:focus
    background transparent
  .el-input-group__append, .el-input-group__prepend
    width 140px
    border 1px solid $c4
    .is-disabled
      color $c4
  .el-form-item__error
    font-size 14px
  .el-input .el-input__clear
    font-size 16px
    color $c2
  .el-checkbox__inner
    width 20px
    height 20px
  .el-checkbox__inner::after
    width 6px
    height 12px
    left 5px
</style>